// extracted by mini-css-extract-plugin
module.exports = {"row":"NotAuthorized_row__1aZUY","flexColumn":"NotAuthorized_flexColumn__3t1rC"};